import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/medicalPatient/video/sub/rtlsVideo3.mp4';

export default {
  banner: {
    title: 'Theo dõi vị trí bệnh nhân',
    desc: 'Tại các cơ sở y tế, có những bệnh nhân cần được quản lý đặc biệt. Không cần phải giám sát trực tiếp 24/24. Hệ thống giúp theo dõi vị trí bệnh nhân chính xác và nhanh chóng theo thời gian thực.',
  },

  video: {
    title: 'Phương pháp quản lý bệnh nhân an toàn theo thời gian thực.',
    desc: 'Công nghệ theo dõi vị trí thời gian thực (RTLS) giúp theo dõi vị trí của bệnh nhân một cách liên tục.<br/>Điều này không chỉ giúp giảm đáng kể nhân lực và chi phí quản lý bệnh nhân mà còn cho phép xây dựng một hệ thống giám sát <strong>an toàn và hiệu quả hơn</strong>.',
    play: video,
  },

  func: [
    {
      title: 'Theo dõi vị trí thời gian thực',
      desc: 'Theo dõi theo thời gian thực vị trí hiện tại của bệnh nhân trong khuôn viên cơ sở y tế. Nếu bệnh nhân tiến gần đến khu vực cấm trong bệnh viện, hệ thống sẽ gửi thông báo theo thời gian thực cho người quản lý.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh chóng',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: 'Điều tra dịch tễ virus',
      desc: 'Sau đại dịch COVID-19, việc ứng phó sớm với các bệnh truyền nhiễm trở nên quan trọng hơn bao giờ hết. Bằng cách truy vết lộ trình di chuyển của người nhiễm bệnh, có thể nhanh chóng xác định người đã tiếp xúc hoặc nghi nhiễm, từ đó ngăn chặn sự lây lan trong cơ sở y tế ngay từ đầu.',
      sub1: 'Xác định đối tượng/khu vực nguy cơ',
      icon1: IconWarningGray,
      sub2: 'Lưu trữ dữ liệu trên nền tảng đám mây',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: 'Phát hiện té ngã',
      desc: 'Bệnh nhân cao tuổi và những người gặp khó khăn trong việc đi lại luôn có nguy cơ bị té ngã. Để có thể ứng phó tức thì với những tình huống này, chúng tôi đã xây dựng hệ thống phát hiện các trường hợp này.',
      sub1: 'Độ chính xác cao',
      icon1: IconRulerGray,
      sub2: 'Kết nối dữ liệu nhanh chóng',
      icon2: IconShareGray,
      video: subVideo3,
    },
  ],

  subfunc: {
    title: 'Tính năng đa dạng',
    desc: 'Tại các cơ sở y tế, sức khỏe của bệnh nhân là điều quan trọng nhất. Tình trạng của bệnh nhân cần được theo dõi mọi lúc, mọi nơi và việc ứng phó ban đầu nhanh chóng khi có sự cố là vô cùng cần thiết. Orbro cung cấp các tính năng sau đây nhằm giúp duy trì một môi trường y tế luôn an toàn.',
    data: [
      {
        icon: IconChartRadius,
        title: 'Báo cáo và phân tích',
        desc: 'Dựa trên dữ liệu lộ trình di chuyển của bệnh nhân, hệ thống có thể tạo và phân tích các dữ liệu thống kê.',
      },
      {
        icon: IconBell,
        title: 'Cảnh báo theo thời gian thực',
        desc: 'Khi có tình huống bất thường xảy ra trên lộ trình di chuyển của bệnh nhân, hệ thống sẽ gửi cảnh báo để có thể ứng phó tức thì.',
      },
      {
        icon: IconRoute,
        title: 'Truy xuất lịch sử di chuyển',
        desc: 'Theo dõi lộ trình của một bệnh nhân cụ thể để phòng ngừa các sự cố an toàn.',
      },
      {
        icon: IconDashboard,
        title: 'Nắm bắt hiện trạng',
        desc: 'Xác định được bệnh nhân cụ thể hiện đang di chuyển đến đâu.',
      },
      {
        icon: IconLocation,
        title: 'Dẫn đường trong nhà',
        desc: 'Xác định bệnh nhân hoặc khách thăm bị lạc đường, giúp nhân viên y tế có thể tìm đến và hỗ trợ kịp thời.',
      },
      {
        icon: IconUserCheck,
        title: 'Nâng cao trải nghiệm',
        desc: 'Mang lại sự tin cậy lớn hơn cho những người đến bệnh viện.',
      },
      {
        icon: IconChainLink,
        title: 'Tích hợp dữ liệu',
        desc: 'Kết nối hiệu quả với các hệ thống như RFID, IoT, an ninh và camera.',
      },
      {
        icon: IconSecurity,
        title: 'Bảo mật dữ liệu',
        desc: 'Duy trì mức độ bảo mật dữ liệu cao, đảm bảo cung cấp giải pháp có độ tin cậy vượt trội.',
      },
    ],
  },

  system: {
    title: 'Cấu trúc hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'peoplePackage' }, { tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalWaste' }, { data: 'logisticsSafety' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
